import { c as _c } from "react/compiler-runtime";
import { useEffect, useState, useRef } from 'react';
interface UseScrollAnimationProps {
  threshold?: number;
  rootMargin?: string;
  triggerOnce?: boolean;
}
export const useScrollAnimation = t0 => {
  const $ = _c(9);
  let t1;
  if ($[0] !== t0) {
    t1 = t0 === undefined ? {} : t0;
    $[0] = t0;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const {
    threshold: t2,
    rootMargin: t3,
    triggerOnce: t4
  } = t1;
  const threshold = t2 === undefined ? 0.2 : t2;
  const rootMargin = t3 === undefined ? "0px" : t3;
  const triggerOnce = t4 === undefined ? true : t4;
  const [isVisible, setIsVisible] = useState(false);
  const elementRef = useRef(null);
  let t5;
  let t6;
  if ($[2] !== rootMargin || $[3] !== threshold || $[4] !== triggerOnce) {
    t5 = () => {
      const observer = new IntersectionObserver(t7 => {
        const [entry] = t7;
        if (entry.isIntersecting) {
          setIsVisible(true);
          if (triggerOnce) {
            observer.disconnect();
          }
        } else {
          if (!triggerOnce) {
            setIsVisible(false);
          }
        }
      }, {
        threshold,
        rootMargin
      });
      const currentElement = elementRef.current;
      if (currentElement) {
        observer.observe(currentElement);
      }
      return () => {
        if (currentElement) {
          observer.unobserve(currentElement);
        }
      };
    };
    t6 = [threshold, rootMargin, triggerOnce];
    $[2] = rootMargin;
    $[3] = threshold;
    $[4] = triggerOnce;
    $[5] = t5;
    $[6] = t6;
  } else {
    t5 = $[5];
    t6 = $[6];
  }
  useEffect(t5, t6);
  let t7;
  if ($[7] !== isVisible) {
    t7 = {
      isVisible,
      elementRef
    };
    $[7] = isVisible;
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  return t7;
};